export { default } from './MegaSale';
export type { MegaSaleLayoutProps } from './MegaSale';
